<!-- Not Authorized -->
<div class="misc-wrapper">
    <h1 class="mb-2 mx-2" style="line-height: 6rem; font-size: 6rem">401</h1>
    <h4 class="mb-2 mx-2">You are not authorized! 🔐</h4>
    <p class="mb-6 mx-2">
        You don’t have permission to access this page. Go Home!
    </p>
    <a routerLink="/system/home" class="btn btn-primary mb-10">Back to home</a>
</div>